import { IntroEvent } from 'common/interfaces/api';
import { SAXO_10000_COIN_EVENT } from 'common/utils';
import { generateCookieList } from 'common/utils/trackingTag';
import SaxoCampaignBanner from 'components/organisms/SaxoCampaignBanner';
import { SITE_BASE_URL } from 'config/env';
import { parse } from 'cookie';
import { NextPageContext } from 'next';
import Head from 'next/head';
import { getEvents } from 'service/user';

import styles from './SaxoMission.module.scss';

export default function SaxoMissionPage({
  saxoEvent,
}: {
  saxoEvent?: IntroEvent;
}): JSX.Element {
  return (
    <>
      <Head>
        <title>サクソバンク証券、新規口座開設ミッション</title>
        <meta
          name="description"
          content="PostPrimeは、「お金」にまつわる情報交換ができるコミュニティを提供。ライブ配信・動画・音声・その他の投稿から学べ、また、過去のチャートパターンやテクニカル分析を学習したAI利用することにより、マーケットの評価など様々な分析機能を使うことができます。"
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="サクソバンク証券、新規口座開設ミッション"
        />
        <meta
          property="og:description"
          content="PostPrimeは、「お金」にまつわる情報交換ができるコミュニティを提供。ライブ配信・動画・音声・その他の投稿から学べ、また、過去のチャートパターンやテクニカル分析を学習したAI利用することにより、マーケットの評価など様々な分析機能を使うことができます。"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content={`${SITE_BASE_URL}/p/saxo_mission`}
        />
        <meta
          name="twitter:title"
          content="サクソバンク証券、新規口座開設ミッション"
        />
        <meta
          name="twitter:description"
          content="PostPrimeは、「お金」にまつわる情報交換ができるコミュニティを提供。ライブ配信・動画・音声・その他の投稿から学べ、また、過去のチャートパターンやテクニカル分析を学習したAI利用することにより、マーケットの評価など様々な分析機能を使うことができます。"
        />
        <link rel="canonical" href={`${SITE_BASE_URL}/p/saxo_mission`} />
      </Head>
      <main className="mx-auto w-full min-w-0 max-w-full px-1 pb-20 pt-4 md:w-[720px] md:max-w-[720px] md:px-2">
        <SaxoCampaignBanner
          className={styles.pageWrapper}
          initialCoinNumber={saxoEvent ? 10000 : 5000}
          saxoEvent={saxoEvent}
        />
      </main>
    </>
  );
}

export const getServerSideProps = async (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  try {
    const eventsData = await getEvents();
    const events = eventsData?.data || [];
    const saxoEvent = events.find(
      (event) => event.type === SAXO_10000_COIN_EVENT,
    );
    if (saxoEvent) {
      return {
        props: {
          saxoEvent,
        },
      };
    }
  } catch (error) {
    /* empty */
  }

  return {
    props: {},
  };
};
